import { CHANGE_ROWS_PER_PAGE, LOCATION_CHANGE } from '../constants'

const initialState = {
  rowsPerPage: 10
}

export default function paginationReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_ROWS_PER_PAGE:
      return {
        ...state,
        rowsPerPage: action.rows
      }
    case LOCATION_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          rowsPerPage: 10
        }
      )

    default:
      return state
  }
}
